import React from 'react';
import { useShowContext } from '../../../shared/uibuilder/show/ShowReactContext';
import { AbstractTask } from '../../../projects/view/tasks/projectTasksService';

import styles from './IsPrivateField.module.scss';

export default function IsPrivateField() {
  const context = useShowContext<AbstractTask>();

  if (context.data?.isPrivate) {
    return (
      <i className={styles.icon}>
        &nbsp;
      </i>
    );
  } else {
    return null;
  }
}
